<template>
  <x-page title="兑换结果">
    <x-result
      title="兑换成功"
      :message="messageObj[sourceType]"
      confirm-text="查看订单"
      guess-resource-position-id="8aaa92be7b66c738017b779b320000c4"
      :confirm-track="{
        name: '支付成功-查看订单',
        id: 'bf9c697c-a19a-49d4-9adf-68e0ea9307ff',
      }"
      @confirm="handleConfirmClick"
    />
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { redirectTo } from '@/router'
  import { Track } from '@/utils'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      Track.provideMark(() => ({
        page: '支付结果',
      })),
    ],
    data() {
      return {
        sourceType: this.$route.query.sourceType,
        messageObj: {
          0: '我们将尽快为您安排发货',
          1: '您可到店核销哦',
          4: '您可到店核销哦',
          1001: '可在天天消费券券包查看',
        },
      }
    },

    methods: {
      // 点击查看订单
      handleConfirmClick() {
        redirectTo('OrderIndex', {
          active: 0,
        })
      },
    },
  })
</script>

<style lang="scss" scoped></style>
